import { FunctionalComponent, h } from 'preact';
import { FinText, KeysOfLocalizations } from '../../../i18n';
import * as appStyles from '../../../assets/global.scss';
import { Properties } from '../../../common';
import { WithStyles } from '../../../style';
import { WidgetTab } from '../../../common/types';
import { connectWithStyles, actions, Actions, BookingState } from '../../../store';

export interface TabProps extends Properties {
  value: WidgetTab;
  selected: boolean;
  peachBorder?: boolean;
  class?: string;
}

interface StoreProps {
  enableAutoFocus: boolean;
}

const mapStateToProps = ({ enableAutoFocus }: BookingState): StoreProps => ({
  enableAutoFocus,
});

type EffectiveProps = TabProps & StoreProps & Actions & WithStyles;

export const Tab: FunctionalComponent<TabProps> = connectWithStyles<TabProps>([appStyles], {
  mapStateToProps,
  actions,
})(({ value, selected, onSelect, tx, enableAutoFocus, class: classes }: EffectiveProps) => {
  const tabLabel: KeysOfLocalizations = `bookingWidgetTabs.tabs.${value}`;

  return (
    <div
      class={tx(classes, 'grow tab', {
        'nordic-blue-900-text tab-active': selected,
        'nordic-blue-900-text transparent-border': !selected,
      })}
    >
      <input
        class={tx('focusInset', 'is-vishidden')}
        id={`tab-${value}`}
        type="radio"
        name="tab"
        value={value}
        onChange={onSelect}
        checked={selected}
        autofocus={enableAutoFocus && selected}
      />
      <label for={`tab-${value}`} class={tx('block grow nowrap link-hover ps-medium-x ps-medium-t ps-xsmall-b')}>
        <FinText id={tabLabel} />
      </label>
    </div>
  );
});
